export default "__VITE_ASSET__BCUBpQuc__"